import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { modeleBoitierService } from '../../services/modeleBoitierService';
import { ModeleBoitier } from '../../types';

interface ModeleBoitierState {
  list: ModeleBoitier[];
  loading: boolean;
  error: string | null;
}

const initialState: ModeleBoitierState = { list: [], loading: false, error: null };

export const fetchModelesBoitier = createAsyncThunk('modelesBoitier/fetchAll', () =>
  modeleBoitierService.getAll()
);

export const createModeleBoitier = createAsyncThunk('modelesBoitier/create', (nom: string) =>
  modeleBoitierService.create(nom)
);

export const updateModeleBoitier = createAsyncThunk(
  'modelesBoitier/update',
  ({ id, nom }: { id: number; nom: string }) => modeleBoitierService.update(id, nom)
);

export const deleteModeleBoitier = createAsyncThunk('modelesBoitier/delete', async (id: number) => {
  await modeleBoitierService.delete(id);
  return id;
});

const modeleBoitierSlice = createSlice({
  name: 'modelesBoitier',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchModelesBoitier.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchModelesBoitier.fulfilled, (s, a) => { s.loading = false; s.list = a.payload; })
      .addCase(fetchModelesBoitier.rejected, (s, a) => { s.loading = false; s.error = a.error.message ?? 'Erreur'; })
      .addCase(createModeleBoitier.fulfilled, (s, a) => { s.list.push(a.payload); })
      .addCase(updateModeleBoitier.fulfilled, (s, a) => {
        const idx = s.list.findIndex((m) => m.id === a.payload.id);
        if (idx !== -1) s.list[idx] = a.payload;
      })
      .addCase(deleteModeleBoitier.fulfilled, (s, a) => { s.list = s.list.filter((m) => m.id !== a.payload); });
  },
});

export default modeleBoitierSlice.reducer;
